// ScanStatusBadge.tsx — the scan lifecycle state (capturing / refining /
// ready / failed) as an Axios StatusBadge with a semantic tone.
import { StatusBadge } from 'common';
import type { ScanStatus } from '../api';
import { statusTone } from '../format';

export function ScanStatusBadge({ status }: { status: ScanStatus }) {
  return <StatusBadge tone={statusTone(status)}>{status}</StatusBadge>;
}
